import React from 'react';

import { SVGComponentProps } from './svg.types';

const SupportSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M21.334 8C22.4386 8 23.334 8.89543 23.334 10V14C23.334 15.1046 22.4386 16 21.334 16H20.2721C19.78 19.9463 16.4136 23 12.334 23V21C15.6477 21 18.334 18.3137 18.334 15V9C18.334 5.68629 15.6477 3 12.334 3C9.02027 3 6.33398 5.68629 6.33398 9V16H3.33398C2.22941 16 1.33398 15.1046 1.33398 14V10C1.33398 8.89543 2.22941 8 3.33398 8H4.39587C4.88797 4.05369 8.25436 1 12.334 1C16.4136 1 19.78 4.05369 20.2721 8H21.334ZM8.09342 15.7849L9.15356 14.0887C10.0756 14.6662 11.1658 15 12.334 15C13.5022 15 14.5924 14.6662 15.5144 14.0887L16.5746 15.7849C15.3452 16.5549 13.8916 17 12.334 17C10.7764 17 9.3228 16.5549 8.09342 15.7849Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default SupportSVG;
